import React from 'react'

export type UiContextValue = { setUiToLoading(): void; setUiToReady(): void }
export const UiContext = React.createContext<UiContextValue | undefined>(undefined)
